<template>
    <router-view v-slot="{ Component, route }">
        <transition :name="route.meta.transition || 'fade'">
            <component :is="Component" />
        </transition>
    </router-view>
</template>

<script>
    import { defineComponent } from "vue";
    import { API } from "./components/Constants";

    export default defineComponent({
        name: "App",
        data() {
            return {
                duration: this.$store.state.duration,
                token: API.TOKEN,
            };
        },
        async mounted() {
            await this.$store.dispatch("getAbonentInfo");
            await this.$store.dispatch("getPlans");
            await this.$store.dispatch("getUserInfo");
            this.$nextTick()
                .then(() => {
                    this.$store.dispatch("changeLoaderStatus", false);
                });
        },
    });
</script>

<style>
@import "./assets/main.css";

@font-face {
  font-family: "SF Pro";
  src: local("SF Pro"), url("./fonts/SF-Pro-Text-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  unicode-range: U+000-5FF;
}

@font-face {
  font-family: "SF Pro";
  src: local("SF Pro"), url("./fonts/SF-Pro-Text-Medium.otf") format("opentype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
  unicode-range: U+000-5FF;
}

@font-face {
  font-family: "SF Pro";
  src: local("SF Pro"), url("./fonts/SF-Pro-Text-Semibold.otf") format("opentype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
  unicode-range: U+000-5FF;
}

@font-face {
  font-family: "SF Pro";
  src: local("SF Pro"), url("./fonts/SF-Pro-Text-Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
  unicode-range: U+000-5FF;
}

.main {
  width: 100%;
  min-height: 100vh;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-family: "SF Pro", serif;
  color: #061029;
  overflow: auto;
  box-sizing: border-box;
}

.container {
  width: calc(100% - 32px);
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.block__title {
  align-self: flex-start;
  margin-bottom: 16px;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: -0.02em;
  font-weight: 600;
  color: #061029;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

.ruble {
  font-family: "SF Pro", sans-serif;
  letter-spacing: -2px;
}
</style>
